import { t } from 'i18next';

export enum TlsVersion {
  TLS13 = 'TLS13',
  TLS12 = 'TLS12',
  NONE = 'NONE',
  UNKNOWN = 'UNKNOWN',
}

export const formatTlsVersion = (value: TlsVersion) => {
  switch (value) {
    case TlsVersion.TLS13:
      return '1.3';
    case TlsVersion.TLS12:
      return '<= 1.2';
    case TlsVersion.NONE:
      return t('tlsVersion.none');
    case TlsVersion.UNKNOWN:
      return t('tlsVersion.unknown');
    default:
      return value;
  }
};
